export const SECTION_COLLAPSE_OPEN_ARIA_LABEL_PREFIX = 'Abrir'
export const SECTION_COLLAPSE_CLOSE_ARIA_LABEL_PREFIX = 'Cerrar'
